module.exports = __webpack_public_path__ + "img/Puente_Istobal_FLEX5_3_Extended_Alto_Blanco-default-front.195c9733.jpg";